export default class Loyalty {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.$input = this.$component.querySelector('.js-basket-page__loyalty__input')

        this.init()
    }

    init() {
        this.addObservers()
    }

    reInit() {
    }

    addObservers() {
        let self = this

        // this.$component.on('click', '.js-basket-page__loyalty__max', function (e) {
        //     self.max(this)
        // })
    }

    // max(link) {
    //     console.log('max - start')
    //     this.$input.value = link.dataset.balance
    // }
}
